
export default [
    // signup route with optional refererral link
    {
        path: '/join/:ref?',
        name: 'signup',
        component: () => import(/* webpackChunkName: "about" */ '@/views/signupView.vue'),
        meta: {
            layout: 'blank'
        }
    },
    // login form view
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/loginView.vue'),
        meta: {
            layout: 'blank'
        }
    }
]
